// extracted by mini-css-extract-plugin
export default {"segmented":"segmentedCom_segmented__-b7zz","SegmentedContent":"segmentedCom_SegmentedContent__zxQjd"};